import { createContext, useContext, useMemo, useState, useCallback } from 'react';

const storybookState = {
  run: false,
  stepIndex: 0,
  steps: [],
  tourActive: false,
};

export const StorybookContext = createContext({
  state: storybookState,
  setState: () => undefined,
});
StorybookContext.displayName = 'StorybookContext';

export function StorybookProvider(props) {
  const [state, setStateInternal] = useState(storybookState);

  // Custom setState that merges partial updates (like useSetState)
  const setState = useCallback((patch) => {
    setStateInternal((prevState) => {
      if (typeof patch === 'function') {
        return { ...prevState, ...patch(prevState) };
      }
      return { ...prevState, ...patch };
    });
  }, []);

  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [setState, state],
  );

  return <StorybookContext.Provider value={value} {...props} />;
}

export function useStorybookContext() {
  const context = useContext(StorybookContext);

  if (!context) {
    throw new Error('useStorybookContext must be used within a StorybookProvider');
  }

  return context;
}
